<template>
    <!-- eslint-disable -->
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="300" height="286" viewBox="0 0 300 286">
  <defs>
    <filter id="Intersection_1" x="-16" y="-11" width="333" height="303.239" filterUnits="userSpaceOnUse">
      <feOffset dx="-1" dy="4" input="SourceAlpha"/>
      <feGaussianBlur stdDeviation="5" result="blur"/>
      <feFlood flood-opacity="0.161"/>
      <feComposite operator="in" in2="blur"/>
      <feComposite in="SourceGraphic"/>
    </filter>
    <clipPath id="clip-Test2">
      <rect width="300" height="286"/>
    </clipPath>
  </defs>
  <g id="Test2" clip-path="url(#clip-Test2)">
    <path id="Intersection_2" data-name="Intersection 2" d="M147.895,284.565c-39.4-1.649-91.465-9.525-124.416-23.061A228.336,228.336,0,0,1,0,250.3V0H303V256.79q-8.663,4.095-18.678,7.671c-30.766,10.96-86.52,20.294-126.889,20.294C154.143,284.756,150.957,284.694,147.895,284.565Z" transform="translate(0.004 0.002)" :fill="color" opacity="0.548"/>
    <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Intersection_1)">
      <path id="Intersection_1-2" data-name="Intersection 1" d="M144.1,273.012c-56.83-2.4-107.731-23.547-144.1-55.806V0H303V219.562c-36.611,33.157-89.454,53.672-148.2,53.676C151.251,273.239,147.692,273.164,144.1,273.012Z" :fill="color"/>
    </g>
  </g>
</svg>
</template>
<script>
import { Colorable } from '../../mixins';

export default {
    name: 'ProfileBackground',
    mixins: [Colorable],
};
</script>
